"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var ChainUpdaterService_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainUpdaterService = void 0;
const tsyringe_1 = require("tsyringe");
const types_1 = require("../types");
const axios_1 = __importDefault(require("axios"));
const cosmos_1 = require("@keplr-wallet/cosmos");
const chains_1 = require("../chains");
let ChainUpdaterService = ChainUpdaterService_1 = class ChainUpdaterService {
    constructor(kvStore, chainsService) {
        this.kvStore = kvStore;
        this.chainsService = chainsService;
    }
    putUpdatedPropertyToChainInfo(chainInfo) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const updatedProperty = yield this.getUpdatedChainProperty(chainInfo.chainId);
            const chainId = cosmos_1.ChainIdHelper.parse(chainInfo.chainId);
            const updatedChainId = cosmos_1.ChainIdHelper.parse(updatedProperty.chainId || chainInfo.chainId);
            // If the saved property is lesser than the current chain id, just ignore.
            if (updatedChainId.version < chainId.version) {
                return chainInfo;
            }
            const features = (_a = chainInfo.features) !== null && _a !== void 0 ? _a : [];
            for (const updatedFeature of (_b = updatedProperty.features) !== null && _b !== void 0 ? _b : []) {
                if (!features.includes(updatedFeature)) {
                    features.push(updatedFeature);
                }
            }
            return Object.assign(Object.assign({}, chainInfo), {
                chainId: updatedProperty.chainId || chainInfo.chainId,
                features,
            });
        });
    }
    clearUpdatedProperty(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.kvStore.set(cosmos_1.ChainIdHelper.parse(chainId).identifier, null);
            this.chainsService.clearCachedChainInfos();
        });
    }
    tryUpdateChain(chainId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const chainInfo = yield this.chainsService.getChainInfo(chainId);
            // If chain id is not fomatted as {chainID}-{version},
            // there is no way to deal with the updated chain id.
            if (!cosmos_1.ChainIdHelper.hasChainVersion(chainInfo.chainId)) {
                return;
            }
            const updates = yield ChainUpdaterService_1.checkChainUpdate(chainInfo);
            if (updates.explicit || updates.slient) {
                const currentVersion = cosmos_1.ChainIdHelper.parse(chainInfo.chainId);
                if (updates.chainId) {
                    const fetchedChainId = updates.chainId;
                    const fetchedVersion = cosmos_1.ChainIdHelper.parse(fetchedChainId);
                    if (currentVersion.identifier === fetchedVersion.identifier &&
                        currentVersion.version < fetchedVersion.version) {
                        yield this.saveChainProperty(currentVersion.identifier, {
                            chainId: fetchedChainId,
                        });
                    }
                }
                if (updates.features && updates.features.length > 0) {
                    const savedChainProperty = yield this.getUpdatedChainProperty(chainInfo.chainId);
                    const updateFeatures = (_a = savedChainProperty.features) !== null && _a !== void 0 ? _a : [];
                    for (const feature of updates.features) {
                        if (!updateFeatures.includes(feature)) {
                            updateFeatures.push(feature);
                        }
                    }
                    yield this.saveChainProperty(currentVersion.identifier, {
                        features: updateFeatures,
                    });
                }
            }
        });
    }
    getUpdatedChainProperty(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const version = cosmos_1.ChainIdHelper.parse(chainId);
            return yield this.loadChainProperty(version.identifier);
        });
    }
    saveChainProperty(identifier, chainInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const saved = yield this.loadChainProperty(identifier);
            yield this.kvStore.set(identifier, Object.assign(Object.assign({}, saved), chainInfo));
            this.chainsService.clearCachedChainInfos();
        });
    }
    loadChainProperty(identifier) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainInfo = yield this.kvStore.get(identifier);
            if (!chainInfo)
                return {};
            return chainInfo;
        });
    }
    /**
     * Returns wether the chain has been changed.
     * Currently, only check the chain id has been changed.
     * @param chainInfo Chain information.
     */
    static checkChainUpdate(chainInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainId = chainInfo.chainId;
            // If chain id is not fomatted as {chainID}-{version},
            // there is no way to deal with the updated chain id.
            if (!cosmos_1.ChainIdHelper.hasChainVersion(chainId)) {
                return {
                    explicit: false,
                    slient: false,
                };
            }
            const instance = axios_1.default.create({
                baseURL: chainInfo.rpc,
            });
            // Get the status to get the chain id.
            const result = yield instance.get("/status");
            const resultChainId = result.data.result.node_info.network;
            const version = cosmos_1.ChainIdHelper.parse(chainId);
            const fetchedVersion = cosmos_1.ChainIdHelper.parse(resultChainId);
            // TODO: Should throw an error?
            if (version.identifier !== fetchedVersion.identifier) {
                return {
                    explicit: false,
                    slient: false,
                };
            }
            const restInstance = axios_1.default.create({
                baseURL: chainInfo.rest,
            });
            let staragteUpdate = false;
            try {
                if (!chainInfo.features || !chainInfo.features.includes("stargate")) {
                    // If the chain doesn't have the stargate feature,
                    // but it can use the GRPC HTTP Gateway,
                    // assume that it can support the stargate and try to update the features.
                    yield restInstance.get("/cosmos/base/tendermint/v1beta1/node_info");
                    staragteUpdate = true;
                }
            }
            catch (_a) { }
            let ibcGoUpdates = false;
            try {
                if ((!chainInfo.features || !chainInfo.features.includes("ibc-go")) &&
                    (staragteUpdate ||
                        (chainInfo.features && chainInfo.features.includes("stargate")))) {
                    // If the chain uses the ibc-go module separated from the cosmos-sdk,
                    // we need to check it because the REST API is different.
                    const result = yield restInstance.get("/ibc/apps/transfer/v1/params");
                    if (result.status === 200) {
                        ibcGoUpdates = true;
                    }
                }
            }
            catch (_b) { }
            let ibcTransferUpdate = false;
            try {
                if ((!chainInfo.features || !chainInfo.features.includes("ibc-transfer")) &&
                    (staragteUpdate ||
                        (chainInfo.features && chainInfo.features.includes("stargate")))) {
                    const isIBCGo = ibcGoUpdates ||
                        (chainInfo.features && chainInfo.features.includes("ibc-go"));
                    // If the chain doesn't have the ibc transfer feature,
                    // try to fetch the params of ibc transfer module.
                    // assume that it can support the ibc transfer if the params return true, and try to update the features.
                    const result = yield restInstance.get(isIBCGo
                        ? "/ibc/apps/transfer/v1/params"
                        : "/ibc/applications/transfer/v1beta1/params");
                    if (result.data.params.receive_enabled &&
                        result.data.params.send_enabled) {
                        ibcTransferUpdate = true;
                    }
                }
            }
            catch (_c) { }
            let noLegacyStdTxUpdate = false;
            try {
                if ((!chainInfo.features ||
                    !chainInfo.features.includes("no-legacy-stdTx")) &&
                    (staragteUpdate ||
                        (chainInfo.features && chainInfo.features.includes("stargate")))) {
                    // The chain with above cosmos-sdk@v0.44.0 can't send the legacy stdTx,
                    // Assume that it can't send the legacy stdTx if the POST /txs responses "not implemented".
                    const result = yield restInstance.post("/txs", undefined, {
                        validateStatus: (status) => {
                            return (status >= 200 && status < 300) || status === 501;
                        },
                    });
                    if (result.status === 501 &&
                        result.data.code === 12 &&
                        result.data.message === "Not Implemented") {
                        noLegacyStdTxUpdate = true;
                    }
                }
            }
            catch (_d) { }
            const features = [];
            if (staragteUpdate) {
                features.push("stargate");
            }
            if (ibcGoUpdates) {
                features.push("ibc-go");
            }
            if (ibcTransferUpdate) {
                features.push("ibc-transfer");
            }
            if (noLegacyStdTxUpdate) {
                features.push("no-legacy-stdTx");
            }
            return {
                explicit: version.version < fetchedVersion.version,
                slient: staragteUpdate ||
                    ibcGoUpdates ||
                    ibcTransferUpdate ||
                    noLegacyStdTxUpdate,
                chainId: resultChainId,
                features,
            };
        });
    }
};
ChainUpdaterService = ChainUpdaterService_1 = __decorate([
    tsyringe_1.singleton(),
    __param(0, tsyringe_1.inject(types_1.TYPES.UpdaterStore)),
    __param(1, tsyringe_1.inject(tsyringe_1.delay(() => chains_1.ChainsService))),
    __metadata("design:paramtypes", [Object, chains_1.ChainsService])
], ChainUpdaterService);
exports.ChainUpdaterService = ChainUpdaterService;
//# sourceMappingURL=service.js.map